var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('creator-video-index-items',{key:_vm.$route?.params?.slug})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }